import script from "./NotionWorkspaceView.vue?vue&type=script&setup=true&lang=js"
export * from "./NotionWorkspaceView.vue?vue&type=script&setup=true&lang=js"

import "./NotionWorkspaceView.vue?vue&type=style&index=0&id=bb9f6f90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb9f6f90"]])

export default __exports__